import { render, staticRenderFns } from "./pro-result-acceptance.vue?vue&type=template&id=27d5448d&scoped=true"
import script from "./pro-result-acceptance.vue?vue&type=script&lang=js"
export * from "./pro-result-acceptance.vue?vue&type=script&lang=js"
import style0 from "./pro-result-acceptance.vue?vue&type=style&index=0&id=27d5448d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5448d",
  null
  
)

export default component.exports